module.exports = __webpack_public_path__ + "media/images/pic/adventure-fb90677141885ce975c97b07c053c62c.svg";